import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import AddCourse from "./addCourse";
import EditCourse from "./editCourse";
import {
  MODAL_HEADER_STYLE,
  MODAL_SUBMIT_BTN_CLASS,
  MODAL_SUBMIT_BTN_STYLE,
  MODAL_CANCEL_BTN_CLASS,
} from "./ProviderSettingsModal";
import "../../styles/tailwind.css";

export const COURSE_ADD_FORM_ID = "provider-add-course-form";

export const getCourseEditFormId = (courseId) =>
  `provider-edit-course-form-${courseId}`;

function CourseAddEditModal({
  show,
  mode,
  provider,
  courseId,
  onClose,
  onSuccess,
}) {
  const [saving, setSaving] = useState(false);
  const isAdd = mode === "add";
  const isMigration = provider?.category === "Migration";
  const entityLabel = isMigration ? "Application" : "Course";
  const title = isAdd ? `Add New ${entityLabel}` : `Edit ${entityLabel}`;
  const formId = isAdd ? COURSE_ADD_FORM_ID : getCourseEditFormId(courseId);
  const submitLabel = saving
    ? isAdd
      ? "Creating..."
      : "Updating..."
    : isAdd
      ? "Create"
      : "Update";

  useEffect(() => {
    if (!show) {
      setSaving(false);
    }
  }, [show]);

  if (!provider) {
    return null;
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      scrollable
      size="xl"
      backdropClassName="!z-[1060]"
      className="provider-course-modal !z-[1070]"
      dialogClassName="provider-course-modal-dialog !my-1 !max-w-7xl !w-[calc(100%-1rem)]"
      contentClassName="!flex !min-h-[88vh] !max-h-[96vh] !flex-col !overflow-hidden !rounded-xl !border !border-gray-200 !bg-white !shadow-xl"
    >
      <Modal.Header
        closeButton={false}
        className="!flex shrink-0 items-center justify-between !border-0 px-4 py-3"
        style={MODAL_HEADER_STYLE}
      >
        <Modal.Title className="!mb-0 text-lg font-bold text-white">
          {title}
        </Modal.Title>
        <button
          type="button"
          onClick={onClose}
          disabled={saving}
          className="border-0 bg-transparent text-2xl leading-none text-white transition hover:text-white/90 disabled:opacity-60"
          aria-label="Close"
        >
          &times;
        </button>
      </Modal.Header>

      <Modal.Body className="!min-h-[calc(88vh-7rem)] !max-h-[calc(96vh-7rem)] !flex-1 overflow-y-auto px-4 py-4">
        {isAdd ? (
          <AddCourse
            key={`add-course-${provider.id}`}
            embedded
            formId={COURSE_ADD_FORM_ID}
            providerId={provider.id}
            providerName={provider.name}
            category={provider.category}
            providerCountry={provider.country}
            onSuccess={onSuccess}
            onCancel={onClose}
            onSavingChange={setSaving}
          />
        ) : (
          <EditCourse
            key={`edit-course-${courseId}`}
            embedded
            formId={getCourseEditFormId(courseId)}
            courseId={courseId}
            providerId={provider.id}
            providerName={provider.name}
            category={provider.category}
            providerCountry={provider.country}
            onSuccess={onSuccess}
            onCancel={onClose}
            onSavingChange={setSaving}
          />
        )}
      </Modal.Body>

      <Modal.Footer className="shrink-0 border-t border-gray-100 px-4 py-3">
        <button
          type="button"
          onClick={onClose}
          disabled={saving}
          className={MODAL_CANCEL_BTN_CLASS}
        >
          Cancel
        </button>
        <button
          type="submit"
          form={formId}
          disabled={saving}
          className={MODAL_SUBMIT_BTN_CLASS}
          style={MODAL_SUBMIT_BTN_STYLE}
        >
          {submitLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default CourseAddEditModal;
